<template>
    <transition name="alert-dialog">
        <article
            :style="{...generateStylingVariables(props.content.style)}"
            v-show="store.state.component.organism.alertDialog.show"
            class="alert-dialog"
        >
            <div
                class="alert-dialog__backdrop"
                @click="store.state.component.organism.alertDialog.show = false"
            />
            <div class="alert-dialog__wrapper">
                <div class="alert-dialog__inner container">
                    <div class="alert-dialog__container">
                        <div class="alert-dialog__header">
                            <zoe-atom-text
                                v-if="stringIsNotEmpty(content.title.value)"
                                class="alert-dialog__title"
                                :item="content.title.value"
                            />

                            <div
                                class="alert-dialog__close"
                                @click="store.state.component.organism.alertDialog.show = false"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M21.072 0.502176C21.7414 -0.167392 22.8285 -0.167392 23.4979 0.502176C24.1674 1.17174 24.1674 2.25912 23.4979 2.92869L14.426 11.9973L23.4926 21.0713C24.162 21.7409 24.162 22.8283 23.4926 23.4978C22.8232 24.1674 21.736 24.1674 21.0666 23.4978L12 14.4238L2.92804 23.4925C2.25862 24.162 1.17148 24.162 0.502064 23.4925C-0.167355 22.8229 -0.167355 21.7355 0.502064 21.066L9.57403 11.9973L0.507955 2.9228C-0.161464 2.25323 -0.161464 1.17174 0.507955 0.502176C1.17737 -0.167392 2.26451 -0.167392 2.93393 0.502176L12.0005 9.57081L21.072 0.502176Z" fill=""/>
                                </svg>
                            </div>

                        </div>

                        <zoe-atom-media
                            v-if="content.media.value"
                            class="alert-dialog__media"
                            :item="content.media.value"
                        />

                        <zoe-atom-text
                            v-if="stringIsNotEmpty(content.text.value)"
                            class="popup-notification__text"
                            :item="content.text.value"
                        />
                    </div>
                </div>
            </div>
        </article>
    </transition>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { stringIsNotEmpty } from '../../../../../resources/frontend/js/mixins/get-page-data';
import { generateStylingVariables } from "../../../mixins/styling/styling";
import { componentProps } from '../../../mixins/component/component';

import ZoeAtomText from "@atoms/text/v1.0.0/zoe-atom-text.vue";
import ZoeAtomMedia from "@atoms/media/v1.0.0/zoe-atom-media.vue";

const props = defineProps({
    content: componentProps.content,
});

const store = useStore();

onBeforeMount(() => {
    store.commit('component/setOrganismValue', {
        component: 'alertDialog',
        object: { show: false },
    });
});

</script>

<style lang="scss" scoped>
@use 'zoe-molecule-alert-dialog';

@layer molecule {
    .alert-dialog {
        --background: v-bind('content.style.background.value');
        --close-background: v-bind('content.style.closeBackground.value');
        --backdrop-background: v-bind('content.style.backdropBackground.value');
    }
}
</style>
